import React, { forwardRef, memo } from 'react';

import { NumberFormat } from './helpers';
import KTextField from './TextField';

import { KInputProps } from '../types';

const KInputCurrency = forwardRef<HTMLInputElement, KInputProps>(
  (props, ref) => {
    return (
      <KTextField
        {...props}
        ref={ref}
        InputProps={{
          ...props.InputProps,
          inputComponent: NumberFormat
        }}
      />
    );
  }
);

export default memo(KInputCurrency);
